"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestEndpoint = getRequestEndpoint;
function getRequestEndpoint() {
    return "/open-request";
}
//# sourceMappingURL=request.js.map